const _ = require('lodash');

const getCustomers = async () => {
  let res = await fetch(`/.netlify/functions/customers?type=getAll`);
  if (res) {
    res = await res.json();
  }
  return res;
}

const addCampaign = async (payload) => {
  let res = await fetch('/.netlify/functions/campaigns?type=addCampaign', {
      body: JSON.stringify(payload),
      method: 'POST'
  });
  if (res) {
    res = await res.json();
  }
  return res;
}

const editCampaign = async (payload, campaignId) => {
  const data = {
      ...payload,
      id: campaignId,
  }
  let res = await fetch('/.netlify/functions/campaigns?type=editCampaign', {
      body: JSON.stringify(data),
      method: 'POST'
  });
  if (res) {
    res = await res.json();
  }
  return res;
}

const createNewSurvey = async (surveyData, campaignId) => {
  const data = {
      id: _.get(surveyData, 'id'),
      campaign: campaignId,
      workspace: process.env.REACT_APP_ACTIVE_WORKSPACE,
      language: _.get(surveyData, 'settings.language'),
      monitor_fields: _.get(surveyData, 'hidden'),
      name: _.get(surveyData, 'title')
  };
  let res = await fetch('/.netlify/functions/surveys?type=createNewSurvey', {
    body: JSON.stringify(data),
    method: 'POST'
  });
  if (res) {
    res = await res.json();
  }
  return res;
}

const addNewCustomer = async (payload) => {
  let res = await fetch('/.netlify/functions/customers?type=addNewClient', {
      body: JSON.stringify(payload),
      method: 'POST'
  });
  if (res) {
    res = await res.json();
  }
  return res;
}

const editCustomer = async (payload, customerId) => {
  const data = {
      ...payload,
      id: customerId,
  }
  let res = await fetch('/.netlify/functions/customers?type=editClient', {
      body: JSON.stringify(data),
      method: 'POST'
  });
  if (res) {
    res = await res.json();
  }
  return res;
}

const editSurvey = async (payload) => {
  let res = await fetch('/.netlify/functions/surveys?type=editSurvey', {
      body: JSON.stringify(payload),
      method: 'POST'
  });
  if (res) {
    res = await res.json();
  }
  return res;
}
  
const VaultApiRequestService = {
  getCustomers,
  createNewSurvey,
  addCampaign,
  editCampaign,
  addNewCustomer,
  editCustomer,
  editSurvey
};
  
export default VaultApiRequestService;
